import { Field, FieldProps } from 'formik';
import { CheckboxComponent } from '../Checkbox';

interface FormikCheckboxProps {
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
}

export const FormikCheckbox: React.FC<FormikCheckboxProps> = ({
  name,
  label,
  required,
  disabled
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <CheckboxComponent
          checked={field.value}
          onChange={value => form.setFieldValue(name, value)}
          disabled={disabled}
          label={label}
          required={required}
          name={name}
        />
      )}
    </Field>
  );
};
